<script>
    import wrappedFetch from "../../wrappedFetch.js";
    import Router from "../../router.js";
    import Modal from "./modalconfirm.svelte";
    import { AuthUser } from "../../store.js";

    
    export let showModal = true;  

    let username;
    let errorMsg ='';
    let isButtonLoading = false;
    
    const impersonate = async (username) => {      
        if (username == null || username == "") {
            errorMsg = "Please provide username"; 
            return false;   
        }     
        isButtonLoading = true;
        let resp = await wrappedFetch(
            `/api/user/Impersonate?username=${username}`,
            {
                method: "post",
            }
        );
        let newUser = await resp.json();

        
        
        isButtonLoading = false;
        
        if(newUser.user == null)
        {
            errorMsg = "User not found";     
            return false;   
        }

        AuthUser.set(newUser.user);
        showModal = false;
        Router.route("/");
    };
</script>

<Modal
    bind:showModal
    zindex="1052"
    sizeClass=""
    targetClass="schoolModal"
    buttonText="Impersonate"
    buttonClass="btn-primary"  
    bind:isButtonLoading={isButtonLoading}  
    on:confirm={async () => {
        await impersonate(username);        
    }}>
    <div slot="header">
        <h4 class="title">Impersonate</h4>
    </div>
    <div slot="content">           
        <label for="username">Username</label>
        <input type="text" class="form-control" required bind:value={username} >
           
        {#if errorMsg!=''}
            <br>
			<span class="text-danger">{errorMsg}</span>
        {/if}
    </div>
</Modal>
